/**
 * Constants for the Dependency Manager
 */

/**
 * Default separator used for canonical field identities (schema paths)
 * This separator MUST NOT appear in field names
 * Using > as it's unlikely to appear in field names
 */
export const DEFAULT_ID_SEPARATOR = '>';

/**
 * Regex pattern to detect illegal characters in field names
 * Based on the configured separator
 */
export const createIllegalCharPattern = (separator: string): RegExp => {
  const escapedSeparator = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(escapedSeparator);
};
